import { normalizeErrorMessage } from './errorUtils';

// Mirrors the Supabase project's password policy (Auth settings:
// password_min_length = 6, password_required_characters = lower/upper/digit,
// leaked-password protection on). Keep in sync if that config changes —
// otherwise passwords pass the client check and bounce off GoTrue with a 422.
export const PASSWORD_POLICY_HINT =
  'At least 6 characters, including an uppercase letter, a lowercase letter and a number.';

const CHARACTER_CLASS_MESSAGE =
  'Password must include an uppercase letter, a lowercase letter and a number.';

export const validatePasswordPolicy = (password: string): string | null => {
  if (password.length < 6) {
    return 'Password must be at least 6 characters.';
  }
  if (!/[a-z]/.test(password) || !/[A-Z]/.test(password) || !/[0-9]/.test(password)) {
    return CHARACTER_CLASS_MESSAGE;
  }
  return null;
};

export const friendlyPasswordError = (
  error: unknown,
  fallback = 'Failed to update password.'
): string => {
  const authError = error as { code?: string; reasons?: string[] } | null | undefined;
  if (authError?.code === 'weak_password') {
    // The character/length reasons should be caught client-side by
    // validatePasswordPolicy; the pwned (breached-password) check only
    // runs on the Supabase server, so it can always come back.
    if (authError.reasons?.includes('pwned')) {
      return 'This password appears in known data breaches, so it is too easy to guess. Please choose a different one.';
    }
    return CHARACTER_CLASS_MESSAGE;
  }
  if (authError?.code === 'same_password') {
    return 'Your new password must be different from your current password.';
  }
  return normalizeErrorMessage(error, fallback);
};
